import { useTranslation } from 'react-i18next';
import React from 'react';
import { downloadImage } from '~/utils/downImg';

import './index.less';

export default function MediaPop({ mediaData }) {
  const { t } = useTranslation();
  const onSaveImg = () => {
    downloadImage(mediaData.image, mediaData.title);
  };
  return (
    <div styleName="media_pop_wrap">
      <div styleName="media_pop_top">
        <img src={mediaData?.image} alt="" />
      </div>
      {/* <div styleName="change_left_png"></div>
      <div styleName="change_right_png"></div> */}
      <div styleName="media_pop_down">
        <span>{mediaData?.title}</span>

        <span onClick={() => onSaveImg()}>
          {t('download')}
          <div styleName="down_arrow"></div>
        </span>
      </div>
    </div>
  );
}
